// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l7c_","delete":"styles_delete__177VS","update":"styles_update__2JsIt","add":"styles_add__10vRw"};